module.exports = __webpack_public_path__ + "img/kandume.1426d77f.png";